import { render, staticRenderFns } from "./table-component.vue?vue&type=template&id=341b87ac&scoped=true&"
import script from "./table-component.vue?vue&type=script&lang=js&"
export * from "./table-component.vue?vue&type=script&lang=js&"
import style0 from "./table-component.vue?vue&type=style&index=0&id=341b87ac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341b87ac",
  null
  
)

export default component.exports